var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"margin-bottom":"30px","margin-top":"25px"}},[_vm._v("Loan Information")]),_c('Input',{attrs:{"inputField":_vm.inputs.justification,"inputName":"Provide a brief description of what your business does.","inputType":"string"}}),_c('Choices',{attrs:{"inputField":_vm.inputs.loanuse,"inputName":"What will your business be using the loan for?","options":[
      'Inventory',
      'Second Location',
      'Payroll',
      'Equipment Purchase',
      'Supplies',
      'Loan Consolidation' ]}}),_c('div',{staticClass:"buttons is-right"},[_c('a',{staticClass:"button is-link padded-button next-button",on:{"click":_vm.next}},[_vm._v("Continue")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }